import sanitize from 'sanitize-html';
import convertAttachments from '../convertAttachments';
import parseAndDeserialize from '../../parseAndDeserialize';
import { Attachment } from '~/graphql/types';
import ELEMENTS from '~/components/organism/PluginsEditor/components/elements/elementsEnum';
import { defaultSanitizeOptions } from '../../flows/convertTemplateStringToSlate';
import type { EditorValue } from '../../../types';

/**
 * This is used when we have html and attachments in an editor. No mappings (like in Signature editor)
 *
 *
 * @param {string} html
 * @param {Array<Attachment>} attachments
 * @param {boolean} markAsPendingImage
 */

type Params = {
  html: string;
  attachments?: Array<Attachment>;
  markAsPendingImage?: boolean;
  customElements?: Array<ELEMENTS>;
};
const convertHtmlToSlateFragment = ({
  html,
  attachments = [],
  markAsPendingImage = false,
  customElements,
}: Params): EditorValue => {
  const sanitized = sanitize(html, defaultSanitizeOptions);
  const convertedHtml = convertAttachments({
    str: sanitized,
    attachments,
  });
  const parsed = parseAndDeserialize({
    html: convertedHtml,
    markAsPendingImage,
    customElements,
  });

  return parsed;
};

export default convertHtmlToSlateFragment;
